import { BaseDto } from '../../core';
import { CampaignSetting } from './campaign-setting.entity';
import { SampleProduct } from './sample-product.entity';
import { APPROVED_STATUS } from '../../shared';

export class CampaignSettingMapperSampleProduct extends BaseDto<CampaignSettingMapperSampleProduct> {
  id: number;
  campaignSettingId: number;
  sampleProductId: number;
  sort: number;
  approvedStatus: APPROVED_STATUS;
  approvedStatusUpdated: Date | null;
  created: Date | null;
  campaignSetting: CampaignSetting;
  sampleProduct: SampleProduct;

  userSelectedProductCount?: number;

  obtainRuleValueRangeByStock: number;

  checkObtainRuleValueRange() {
    const availableCount = Math.floor(this.sampleProduct.stock / this.sampleProduct.inboxQuantity);
    this.obtainRuleValueRangeByStock = availableCount;
  }
}
